import React from 'react';
import { connect } from 'react-redux';
import { accountOperations } from 'insured-ui-state-mgmt/dist/ducks/account';
import PropTypes from 'prop-types';
import Loading from '../registrationScreens/Loading';

import { AddPolicyPage } from '../assets/constants/constants';
import { Modal, Button, Alert } from 'react-bootstrap';

class EmailSentScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      message: '',
      show: true,
      response: props.transition._targetState._params.response || { email: '' },
    };
    this.notificationSystem = React.createRef();
  }

  componentDidMount() {
    if (!this.props.policyInfo.hasOwnProperty('policyNumber') && !this.props.policyInfo.hasOwnProperty('policyType')) {
      this.props.transition.router.stateService.go('registrationScreen1');
    }
  }

  _continue() {
    window.location.href = AddPolicyPage;
  }

  handleClose = () => {
    this.setState(
      {
        show: false,
      },
      () => {
        this.props.transition.router.stateService.go('registrationScreen1');
        this.props.clearAccount();
      }
    );
  };

  render() {
    const { loading, show, response } = this.state;
    return (
      <Modal
        show={show}
        onHide={this.handleClose}
        backdrop="static"
        dialogClassName="modal-md modal_400 relative_position"
      >
        <Modal.Header closeButton={!loading}>
          <Modal.Title>Account Successfully Created</Modal.Title>
        </Modal.Header>

        {this.state.loading && <Loading show={this.state.loading} />}

        {!this.state.loading && (
          <Modal.Body style={{ margin: 20, minHeight: 0 }} bsClass="modal-body modal_body_450">
            <p>
              Thank you for creating an account. Please access your account using email{' '}
              <strong>{response.email}</strong>.
            </p>

            <Button bsStyle="primary" bsSize="large" block disabled={loading} onClick={() => this._continue()}>
              Access Account
            </Button>

            {this.props.response &&
              this.props.response.code > 0 &&
              this.props.response.message && (
                <Alert bsStyle="danger" style={{ marginTop: 10 }}>
                  <strong>Api Error</strong> {this.props.response.message}
                </Alert>
              )}
          </Modal.Body>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  account: state.account.registrationDetails,
  response: state.account.response,
  extra: state.extra,
  policyInfo: state.account.policyInfo,
});
const mapDispatchToProps = {
  setAccountInfo: accountOperations.registerUser_1,
  clearAccount: accountOperations.clearAccount,
};
EmailSentScreen.propTypes = {
  $stateParams: PropTypes.object,
  account: PropTypes.object,
  response: PropTypes.object,
  routeParams: PropTypes.object,
  setAccountInfo: PropTypes.func,
  transition: PropTypes.object,
  verifyAccount: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailSentScreen);
